import React from "react";
import CardItem from "./CardItem";
import img1 from "../assets/slide18.jpg";

import styled from "styled-components";

function Cards() {
    const Cards = styled.div`
        padding: 1rem 0;
        background: rgb(31, 1, 16);
        border-bottom: 1px solid rgb(0, 195, 255);
    `;

    const CardDiv1 = styled.div`
        max-width: 1200px;
        margin: 0 auto;
    `;
    const H1 = styled.h1`
        text-align: center;
        color: rgb(0, 195, 255);
    `;
    const Container = styled.div`
        display: flex;
        flex-flow: column;
        align-items: center;
        width: 90%;
        margin: 0 auto;
    `;
    const Container2 = styled.div`
        position: relative;
        margin: 50px 0 45px;
    `;
    const Ul = styled.ul`
        margin-bottom: 24px;
        display: flex;
        gap: 20px;
        @media (max-width: 800px) {
            flex-direction: column;
        }
    `;
    return (
        <Cards>
            <CardDiv1>
                <H1>Meet Our Artists</H1>
                <Container>
                    <Container2>
                        <Ul>
                            <CardItem
                                src={img1}
                                button_1="Stream Music"
                                button_2="View Bio"
                                paragraph="Explore MELIQ-1 music journey through their releases, from debut singles to their latest chart-topping album."
                                label="MELIQ-1"
                                path="/artists"
                            />
                            {/* <CardItem
                                src={slide10}
                                button_1="Stream Music"
                                button_2="View Bio"
                                paragraph="Explore MELIQ.101 music journey through their releases, from debut singles to their latest chart-topping album."
                                label="MELIQ.101"
                                path="/artists"
                            />{" "}
                            <CardItem
                                src={slide10}
                                button_1="Stream Music"
                                button_2="View Bio"
                                paragraph="Explore MELIQ.101 music journey through their releases, from debut singles to their latest chart-topping album."
                                label="MELIQ.101"
                                path="/artists"
                            /> */}
                        </Ul>
                    </Container2>
                </Container>
            </CardDiv1>
        </Cards>
    );
}

export default Cards;
